/**
 * @license
 * Copyright 2022 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { emitEvent, toggleAttribute } from '@tylertech/forge-core';
export class BaseAdapter {
    constructor(_component) {
        this._component = _component;
    }
    getHostAttribute(name) {
        return this._component.getAttribute(name);
    }
    setHostAttribute(name, value = '') {
        this._component.setAttribute(name, value);
    }
    removeHostAttribute(name) {
        this._component.removeAttribute(name);
    }
    toggleHostAttribute(name, hasAttribute, value) {
        toggleAttribute(this._component, hasAttribute, name, value);
    }
    emitHostEvent(type, data = null, bubble = true, cancelable) {
        return emitEvent(this._component, type, data, bubble, cancelable);
    }
    addHostListener(event, callback, options) {
        this._component.addEventListener(event, callback, options);
    }
    removeHostListener(event, callback) {
        this._component.removeEventListener(event, callback);
    }
    addWindowListener(event, callback, options) {
        window.addEventListener(event, callback, options);
    }
    removeWindowListener(event, callback, options) {
        window.removeEventListener(event, callback, options);
    }
    addDocumentListener(event, callback, options) {
        document.addEventListener(event, callback, options);
    }
    removeDocumentListener(event, callback, options) {
        document.removeEventListener(event, callback, options);
    }
    getScreenWidth() {
        return window.innerWidth;
    }
    setBodyAttribute(name, value) {
        document.body.setAttribute(name, value);
    }
    removeBodyAttribute(name) {
        document.body.removeAttribute(name);
    }
    get isConnected() {
        return this._component.isConnected;
    }
}
